export function onlyCountries(geo, countries)
{
	return _.filter(geo, item => _.includes(countries, item.naturalId));
}
